import React from 'react';
import { ArrowRightOutlined, StarFilled } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useI18n } from '../../i18n/I18nContext';
import Reveal from './Reveal';
import './landing.css';

/** Bandeau d'appel à l'action final, commun aux pages publiques. */
const CtaSection: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useI18n();

  return (
    <section id="cta" className="ts-section ts-cta">
      <div className="ts-container">
        <Reveal className="ts-cta-card" y={60} scale={0.97}>
          <div className="ts-cta-star ts-cta-star--1 ts-float" data-speed="0.95">
            <StarFilled />
          </div>
          <div className="ts-cta-star ts-cta-star--2 ts-float--reverse" data-speed="1.05">
            <StarFilled />
          </div>
          <div className="ts-cta-star ts-cta-star--3 ts-float" data-speed="1.1">
            <StarFilled />
          </div>
          <h2 className="ts-title ts-title--light ts-cta-title">{t.cta.title}</h2>
          <p className="ts-lead ts-lead--light">{t.cta.subtitle}</p>
          <div className="ts-cta-buttons">
            <button type="button" className="ts-btn ts-btn--light" onClick={() => navigate('/login')}>
              {t.cta.createAccount}
              <ArrowRightOutlined />
            </button>
            <button type="button" className="ts-btn ts-btn--outline" onClick={() => navigate('/login')}>
              {t.cta.signIn}
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default CtaSection;
